import { asNonUndefined } from '@kaseya-utils';
import { WalkMeWindow, segmentId } from '@core/walk-me/models/custom-window.type';

export const getExternalDomains = (walkMeAPI: WalkMeWindow['WalkMeAPI']): string[] => {
  const segmentsObj = asNonUndefined(walkMeAPI).getLastSegmentsResults();
  const segment = segmentsObj[segmentId];

  const allDomains = new Set<string>();
  if (segment?.conditionsTree?.ConditionsTree) {
    extractDomains(segment.conditionsTree.ConditionsTree).forEach(domain => allDomains.add(domain));
  }

  return [...allDomains];
};

const extractDomains = (node: { leftSon?: unknown; rightSon?: unknown; funcArgs?: { CookieInput: string } }): string[] => {
  let domains: string[] = [];

  if (typeof node === 'object') {
    if (node.funcArgs?.CookieInput) {
      const match = node.funcArgs.CookieInput.match(/\*@(.+)/);
      if (match && match.length > 1) {
        domains.push(match[1]);
      }
    }

    if (node.leftSon) {
      domains = domains.concat(extractDomains(node.leftSon));
    }

    if (node.rightSon) {
      domains = domains.concat(extractDomains(node.rightSon));
    }
  }

  return domains;
};
